import api from '@/api';

const resource = 'ei/cancelamento-diario';

export default {
  getListaCancelamento(data) {
    return api.get(`${resource}`, { params: data });
  },
  getCancelamento(id) {
    return api.get(`${resource}/${id}`);
  },
  postCancelamento(data) {
    return api.post(`${resource}`, data);
  },
  putCancelamento(data) {
    return api.put(`${resource}/${data.identificadorautorizacaocancelamentodiario}`, data);
  },
  deleteCancelamento(id) {
    return api.delete(`${resource}/${id}`);
  }
};
